import React from 'react';
import { useGameStore } from '../../store/game-store.js';

export default function ToastContainer() {
  const toasts = useGameStore(s => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <div key={toast.id} className={`toast toast--${toast.type}`}>
          {toast.message}
        </div>
      ))}
    </div>
  );
}
